import { useMutation } from "@tanstack/react-query"

import i18n from "@/i18n/config"

import { publicApi } from "../apiClient"

interface ValidateCouponParams {
  firstName: string
  lastName: string
  birthDate: string
  couponCode: string
}

interface Coupon {
  FirstName: string
  LastName: string
  BirthDate: string
  CouponCode: string
  CouponDesc: string
  CustomerId: number
}

interface ValidateCouponResponse {
  Success: boolean
  ValidationMessage: string | null
  Coupon: Coupon | null
}

export const useValidateMembersCoupon = () => {
  const validateCouponMutation = useMutation<
    Coupon,
    Error,
    ValidateCouponParams
  >({
    mutationKey: ["validateMembersCoupon"],
    mutationFn: async (params) => {
      const response = await publicApi.get<ValidateCouponResponse>(
        "/common/myskistardeal/validatecoupon",
        {
          params: {
            cultureName: i18n.language,
            couponCode: params.couponCode,
            firstName: params.firstName,
            lastName: params.lastName,
            birthdate: params.birthDate,
          },
        }
      )

      if (!response.data.Success || !response.data.Coupon) {
        throw new Error(response.data.ValidationMessage ?? "Validation failed")
      }

      return response.data.Coupon
    },
    retry: 1,
  })

  return {
    validateCoupon: validateCouponMutation.mutate,
    isLoading: validateCouponMutation.isPending,
  }
}
